import { FormatInput, FormField, InputField, QuestionnaireDescription, useError } from "common";
import { useField } from "formik";
import { omit } from "lodash";
import React from "react";
import { HeightUnit } from "types";
import { SuffixField } from "../Field/SuffixField";
import { FieldProps } from "./TextField";

export const HeightFeetDisplayValue = "ft/in";

export const HeightField = ({ name, field, isRequired, classNames }: FieldProps) => {
    const [props, , helpers] = useField(name);
    const error = useError(name);
    const rest = omit(props, "onChange");
    const suffix = field.unit === HeightUnit.FEET ? HeightFeetDisplayValue : field.unit;
    const isUnitInCms = field.unit === HeightUnit.CM;

    return (
        <FormField label={field.label} name={name} classNames={{ label: classNames?.label }}>
            <QuestionnaireDescription field={field} />
            <SuffixField suffix={suffix ?? ""}>
                {isUnitInCms ? (
                    <FormatInput
                        {...rest}
                        isRequired={isRequired}
                        isError={!!error}
                        onValueChange={({ floatValue }) => {
                            helpers.setValue(floatValue?.toString() ?? "");
                        }}
                    />
                ) : (
                    <InputField isRequired={isRequired} />
                )}
            </SuffixField>
        </FormField>
    );
};
